import type { ButtonHTMLAttributes, ReactNode } from "react";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: "primary" | "tonal" | "ghost";
    leftIcon?: ReactNode;
    isLoading?: boolean;
}

const VARIANT_CLASSES = {
    primary: "bg-primary text-primary-foreground hover:bg-primary/90",
    tonal: "bg-primary/10 text-primary hover:bg-primary/15",
    ghost: "bg-transparent text-foreground hover:bg-accent",
};

export function Button({
    variant = "primary",
    leftIcon,
    isLoading,
    disabled,
    children,
    className = "",
    ...props
}: ButtonProps) {
    return (
        <button
            disabled={disabled || isLoading}
            className={`inline-flex items-center justify-center gap-2 rounded-lg px-4 py-2.5 text-sm font-medium transition-colors disabled:opacity-50 disabled:pointer-events-none ${VARIANT_CLASSES[variant]} ${className}`}
            {...props}
        >
            {isLoading ? (
                <span className="h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent" />
            ) : (
                leftIcon
            )}
            {children}
        </button>
    );
}
